import React from 'react';

import { OrderBlockWrapper } from '../../Common/OrderBlockWrapper';

import { AddonRow } from './components/AddonRow';

import styles from './AddonsList.module.scss';

export const AddonsList = () => {
  return (
    <div>
      <section className={styles.header}>
        <div className={styles.title}>Project Options</div>
        <span className={styles.subtitle}>
          Please select roof scope items applicable to this project then add price. Only items
          listed below can be included in this contract.
        </span>
      </section>

      <OrderBlockWrapper>
        <AddonRow type="rainGutters" />
        <hr className={styles.divider} />

        <AddonRow type="gutters" />
        <hr className={styles.divider} />

        <AddonRow type="decking" />
        <hr className={styles.divider} />

        <AddonRow type="skylights" />
      </OrderBlockWrapper>
    </div>
  );
};
